import type { AppIcon } from "@/components/appIcons";
import { MultiFilterSelectTriggerLabels } from "@/components/ui/multi-filter-select-trigger-labels";
import { SelectTriggerAction } from "@/components/ui/select-trigger-action";
import { cn } from "@/lib/utils";

interface MultiFilterSelectTriggerProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  icon: AppIcon;
  showTriggerIcon: boolean;
  selectedLabel: string | null;
  placeholder: string;
  isFullWidth: boolean;
  active: boolean;
  countLabel: string;
  onClear: () => void;
}

export function MultiFilterSelectTrigger({
  open,
  setOpen,
  icon,
  showTriggerIcon,
  selectedLabel,
  placeholder,
  isFullWidth,
  active,
  countLabel,
  onClear,
}: MultiFilterSelectTriggerProps) {
  return (
    <button
      type="button"
      onClick={() => setOpen(!open)}
      className={cn(
        "flex items-center border rounded-md text-sm cursor-pointer transition-all focus:outline-none focus:ring-1 focus:ring-primary",
        isFullWidth
          ? "w-full min-h-12 gap-3 px-3 py-2.5 bg-secondary border-border"
          : "gap-1.5 pl-2.5 pr-2 h-11 sm:h-10",
        active ? "text-foreground" : "text-muted-foreground hover:border-border/80",
        !isFullWidth &&
          (active ? "bg-primary/10 border-primary/30" : "bg-secondary/50 border-border"),
      )}
    >
      <MultiFilterSelectTriggerLabels
        icon={icon}
        showTriggerIcon={showTriggerIcon}
        selectedLabel={selectedLabel}
        placeholder={placeholder}
        isFullWidth={isFullWidth}
        countLabel={countLabel}
      />
      <SelectTriggerAction
        clearable={active}
        onClear={(event) => {
          event.stopPropagation();
          onClear();
        }}
      />
    </button>
  );
}
